<template>
    <div class="plate-common map-plat">
        <div class="title-wrap">
            <div class="title">
                <img src="@/assets/images/track/title-icon.png" alt="">
                <span>总览数据</span>
            </div>
            <div class="time-wrap" @click="openTimeSelect">
                <span>{{objMapParameter.arrMapPLatTime[0]}}~{{objMapParameter.arrMapPLatTime[1]}}</span>
                <img src="@/assets/images/track/time-icon.png" alt="">
            </div>
        </div>
        <div class="address-wrap">
            <div class="address-item" @click="openOption('DQ')">
                <span>{{filterNameArr(objAddress.speedDqOption,'大区')}}</span>
                <img src="@/assets/images/track/ci.png" alt="">
            </div>
            <div class="address-item" @click="openOption('SF')">
                <span>{{filterNameArr(objAddress.speedProviceOption,'省份')}}</span>
                <img src="@/assets/images/track/ci.png" alt="">
            </div>
            <div class="address-item" @click="openOption('CS')">
                <span>{{filterNameArr(objAddress.speedCityOption,'城市')}}</span>
                <img src="@/assets/images/track/ci.png" alt="">
            </div>
        </div>
        <van-swipe class="my-swipe-map" ref="mapSwiperRef" autoplay="false" :show-indicators="false" :touchable="false">
            <van-swipe-item  class="van-swipe-item van-swipe-item-one">
                <div class="form-tab-wrap">
                    <div class="fixed-left">
                        <div class="form-title">
                            <span>排名</span>
                            <img class="down-icon" src="@/assets/images/track/order.png" alt="">
                        </div>
                        <div class="form-title">
                            <span>姓名</span>
                        </div>
                    </div>
                    <div class="scroll-right" @touchstart="touchStartMapRightOne"
                         @touchmove="touchMoveMapRightOne" @touchend="touchEndMapRightOne" :style="{'transform':`translateX(${objMapParameter.formOneScrollZhenWidth}px)`}">
                        <div class="form-title">转发量</div>
                        <div class="form-title">触达用户数</div>
                        <div class="form-title">手机号</div>
                        <div class="form-title">归属地</div>
                    </div>
                </div>
                <div class="form-content" ref="formContent">
                    <div class="fixed-left" ref="mapFormLeft">
                        <template v-for="(item,index) in objMapParameter.formOneData">
                            <div class="fixed-item-left"
                                 :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}" >
                                <div class="form-title">{{ index + 1 }}</div>
                                <div class="form-title">{{item.name}}</div>
                            </div>
                        </template>
                    </div>
                    <div class="scroll-right" ref="mapFormRight" @touchstart="touchStartMapRightOne"
                         @touchmove="touchMoveMapRightOne" @touchend="touchEndMapRightOne">
                        <template v-for="(item,index) in objMapParameter.formOneData">
                            <div class="fixed-item-right" :style="{'transform':`translateX(${objMapParameter.formOneScrollZhenWidth}px)`}">
                                <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.share_num || 0}}</div>
                                <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.reach_num || 0}}</div>
                                <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.phone || '暂无'}}</div>
                                <div class="form-title" :style="{'background':(index%2==0?'#ffffff':'#F5F7F6')}">{{item.org_name || '暂无'}}</div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tips-other" v-if="objMapParameter.isShowTips">{{objMapParameter.nShowTipsType==0?'暂无更多数据':'加载中▪▪▪'}}</div>
                <div class="vant-pagination-wrap">
                    <van-pagination v-model="objMapParameter.currentPage" :items-per-page="10" :total-items="objMapParameter.nTotal" :show-page-size="7" force-ellipses @change="vantPageChange($event,'MAP_ONE')">
                        <template #prev-text>
                            <van-icon name="arrow-left" />
                        </template>
                        <template #next-text>
                            <van-icon name="arrow" />
                        </template>
                        <template #page="{ text }">{{ text }}</template>
                    </van-pagination>
                </div>
            </van-swipe-item>
        </van-swipe>
        <!--日期区间组件-->
        <van-calendar v-model:show="isShowCale" :default-date="objMapParameter.defaultDate" :min-date="minDate" :max-date="maxDate" color="#00883B" :allow-same-day="true" type="range" @confirm="onConfirmCale" />
        <!--大区,省份,城市下拉-->
        <van-popup  v-model:show="objAddress.isShowSelect" round position="bottom">
            <van-picker
                title="选择"
                :columns="objAddress.speedOption"
                show-toolbar
                @cancel="objAddress.isShowSelect = false"
                @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>

<script>
import oTrack from "@/js/track/indexv3"
export default {
    name: "report",
    data(){
        return{
            minDate: new Date(1990, 1, 1),//日期范围
            maxDate: new Date(),//日期范围
            isShowCale:false,
            objMapParameter:{
                arrMapPLatTime:[],
                formOneScrollZhenWidth:0,
                nShowTipsType:1,
                currentPage:0,
                isShowTips:true,
                formOneData:[],
                nTotal:0,
                formOneStartX:'',
                formOneMoveFlag:true,
                isYMove:0,
                formOneEndX:0,
                formOneScrollWidth:0,
                nPage:0,
                defaultDate:[]
            },
            sCurrentDayStart:'',
            sCurrentDayEnd:'',
            objAddress:{
                isShowSelect:false,
                cascaderValue:'',
                speedOptionType:'',
                speedOption:[],
                speedProviceOption:[],
                speedDqOption:[],
                speedCityOption:[],
                regionProviceCityArr:[],
            }
        }
    },
    created() {
        // 获取当前月首日以及当天日期
        this.sCurrentDayStart=this.getYMD().nowDateStart
        this.sCurrentDayEnd=this.getYMD().nowDateEnd
        // 各模块日期区间使用当前月
        let timeStartEnd = [this.sCurrentDayStart, this.sCurrentDayEnd]
        this.objMapParameter.arrMapPLatTime= timeStartEnd
        this.getReportList()
        this.getConfig()
    },
    methods:{
        //大区,省份筛选配置
        getConfig(){
            oTrack.configArea().then(res=>{
                let result = res.data.data.result
                console.log(result,'配置')
                this.objAddress.speedDqOption=result.district.map(item=>{
                    item.text=item.region_name
                    item.name=item.region_name
                    item.value=item.id
                    item.active=false
                    return item
                })
                this.objAddress.regionProviceCityArr=result.district.map(item=>{
                    item.name=item.region_name
                    item.self_next.forEach(it=>{
                        it.self_next.forEach(i=>{
                            delete  i.self_next
                        })
                    })
                    return item
                })
            })
        },
        // 下拉组件点击
        openOption(type){
            this.objAddress.isShowSelect=true
            this.objAddress.speedOptionType=type
            if(type=="DQ"){
                this.objAddress.speedOption=this.objAddress.speedDqOption
            }else if(type=="SF"){
                this.objAddress.speedOption=this.objAddress.speedProviceOption
            }else if(type=="CS"){
                this.objAddress.speedOption=this.objAddress.speedCityOption
            }
        },
        // 下拉项确认选择
        onConfirm(e){
            if(this.objAddress.speedOptionType=='DQ'){
                this.objAddress.speedDqOption.forEach(it=>{
                    if(it.id==e.id){
                        it.active=true
                        console.log(it)
                        this.objAddress.speedProviceOption=it.self_next.map(i=>{
                            i.text=i.name
                            i.value=i.id
                            return i
                        })
                        this.objAddress.speedCityOption=[]
                    }else{
                        it.active=false
                    }
                })
                this.getReportList()
            }else if(this.objAddress.speedOptionType=='SF'){
                this.objAddress.speedProviceOption.forEach(it=>{
                    if(it.id==e.id){
                        it.active=true
                        // 选择省份,获取当前省份的城市赋值
                        this.objAddress.speedCityOption=it.self_next.map(i=>{
                            i.text=i.name
                            i.value=i.id
                            return i
                        })
                    }else{
                        it.active=false
                    }
                })
                this.getReportList()
            }else if(this.objAddress.speedOptionType=='CS'){
                this.objAddress.speedCityOption.forEach(it=>{
                    if(it.id==e.id){
                        it.active=true
                    }else{
                        it.active=false
                    }
                })
                this.getReportList()
            }
            this.objAddress.isShowSelect=false
        },
        // 通过过滤展示不同的选项文字
        filterNameArr(arr,defaultName){
            let arrFilter = arr.filter(it=>{
                return it.active
            })
            return arrFilter[0]?.name || defaultName
        },
        // 中国标准时间转标准时间
        newDate(time) {
            var date = new Date(time)
            var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            return y + '-' + m + '-' + d
        },
        onConfirmCale(e){
            let timeArr=[this.newDate(e[0]),this.newDate(e[1])]
            this.objMapParameter.arrMapPLatTime=timeArr
            this.getReportList()
            this.isShowCale=false
        },
        // 获取当前年月日
        getYMD(){
            let myDate = new Date()
            let myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
            let myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
            let myToday = myDate.getDate(); //获取当前日(1-31)
            myMonth = myMonth > 9 ? myMonth : '0' + myMonth
            myToday = myToday > 9 ? myToday : '0' + myToday
            let nowDateStart = myYear + '-' +myMonth + '-' + '01'
            let nowDateEnd = myYear + '-' + myMonth + '-' + myToday
            return {nowDateStart,nowDateEnd}
        },
        /**
         * 校验只要是数字（包含正负整数，0以及正负浮点数）就返回true
         **/
        isNumber(val){
            var regPos = /^[0-9]+.?[0-9]*/; //判断是否是数字。
            if(regPos.test(val) ){
                return true;
            }else{
                return false;
            }
        },
        getReportList(){
            let RegionArr = this.objAddress.speedDqOption.filter(it=>{
                return it.active
            })
            let region_id =RegionArr[0]?.id || ''
            let proviceArr = this.objAddress.speedProviceOption.filter(it=>{
                return it.active
            })
            let province =proviceArr[0]?.id || ''
            let cityArr = this.objAddress.speedCityOption.filter(it=>{
                return it.active
            })
            let city=cityArr[0]?.id || ''
            this.$store.commit('loadSwitch',true)
            oTrack.report({region_id,province,city,page:this.objMapParameter.nPage,limit:10,start_time:this.objMapParameter.arrMapPLatTime[0],end_time:this.objMapParameter.arrMapPLatTime[1]}).then(res=>{
                this.$store.commit('loadSwitch',false)
                console.log(res,'数据')
                this.objMapParameter.formOneData=res.data.data.result.list.map(item=>{
                    for (const itKey in item) {
                        if(this.isNumber(item[itKey]) && itKey!='phone'){
                            item[itKey]=this.addSymbol(item[itKey])
                        }
                    }
                    return item
                })
                this.objMapParameter.nTotal=res.data.data.result.total
                if(this.objMapParameter.formOneData.length<10){
                    // 长度小于limit说明无更多数据,展示无更多数据
                    this.objMapParameter.isShowTips=true
                    this.objMapParameter.nShowTipsType=0
                }else if(this.objMapParameter.formOneData.length==10){
                    // 长度大于limit需要判断是否是最后一页,是的话需要展示无更多数据
                    if( this.objMapParameter.nPage==parseInt((this.objMapParameter.nTotal-1)/10)){
                        this.objMapParameter.isShowTips=true
                        this.objMapParameter.nShowTipsType=0
                    }else{
                        this.objMapParameter.isShowTips=false
                    }
                }
            })
        },
        openTimeSelect(){
            let timeArr=[new Date(this.objMapParameter.arrMapPLatTime[0]),new Date(this.objMapParameter.arrMapPLatTime[1])]
            this.objMapParameter.defaultDate=timeArr
            this.isShowCale=true
        },
        // 加千位符
        addSymbol(num){
            var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                    return $1+",";
                });
            })
            return res;
        },
        // 口碑地图第一种表格按下事件
        touchStartMapRightOne(e) {
            console.log(e)
            this.objMapParameter.formOneStartX = e.touches[0].pageX // 开始触摸时的原点
            this.objMapParameter.formOneMoveFlag = true
            this.objMapParameter.isYMove=this.$refs.formContent.scrollTop
        },
        // 口碑地图第一种表格移动事件
        touchMoveMapRightOne(e) {
            let startX = e.touches[0].pageX
            console.log(this.$refs.formContent.scrollTop,this.objMapParameter.isYMove)
            if(this.$refs.formContent.scrollTop!= this.objMapParameter.isYMove)return
            console.log(e)
            if (this.objMapParameter.formOneMoveFlag) {
                if ( this.objMapParameter.formOneEndX) {
                    this.objMapParameter.formOneScrollWidth += (startX - this.objMapParameter.formOneEndX);
                    if (this.objMapParameter.formOneScrollWidth > 0) {
                        this.objMapParameter.formOneScrollWidth = 0
                    } else if (this.objMapParameter.formOneScrollWidth < (-350)) {
                        this.objMapParameter.formOneScrollWidth = -350
                    } else {
                        this.objMapParameter.formOneScrollZhenWidth = JSON.parse(JSON.stringify(this.objMapParameter.formOneScrollWidth));
                    }
                }
                this.objMapParameter.formOneEndX = startX// 结束触摸时的原点
            }
        },
        // 口碑地图第一种表格松开事件
        touchEndMapRightOne(e) {
            this.objMapParameter.formOneMoveFlag = true;
            this.objMapParameter.formOneEndX = 0;
        },
        // vant分页点击改变
        vantPageChange(page,type){
            if(type=='MAP_ONE'){
                this.objMapParameter.nPage=page-1
                this.getReportList()
            }
        },
    }
}
</script>

<style scoped lang="scss">
.plate-common {
    box-sizing: border-box;
    padding: 24px 16px 0 16px;
    border-bottom: 16px solid #F7F7F7;
    width: 100%;

    .title-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            display: flex;
            align-items: center;
            white-space: nowrap;

            img {
                width: 14px;
                height: 32px;
                margin-right: 6px;
            }

            span {
                font-size: 28px;
                font-weight: 500;
                color: #318544;
                white-space: nowrap;
            }
        }

        .time-wrap {
            height: 56px;
            display: flex;
            align-items: center;
            background: #F7F8F8;
            border-radius: 12px;
            padding: 0 12px;

            span {
                font-size: 22px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.4);
            }

            img {
                width: 32px;
                margin-left: 16px;
                height: 32px;
            }
        }
    }
    .address-wrap{
        display: flex;
        align-items: center;
        .address-item{
            display: flex;
            align-items: center;
            margin: 22px 12px 0 12px;
            span{
                font-size: 24px;
                font-weight: 400;
                color: #9B9B9B;
            }
            img{
                width: 20px;
                margin-left: 8px;
            }
        }
    }


    .my-swipe-map {
        margin: 24px 0;
        width: 100%;
        .van-swipe-item{
            overflow: hidden;
        }

        .form-tab-wrap {
            width: 100%;
            height: 80px;
            background: #008C2F;
            border-radius: 16px 16px 0px 0px;
            display: flex;
            align-items: center;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            position: relative;
            z-index: 15;
            //overflow: hidden;

            .fixed-left {
                width: 250px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                z-index: 10;
                border-radius: 16px 0px 0px 0px;
                background: #008C2F;
                height: 100%;
                border-right: 1px solid #dcdfe6;


                .form-title {
                    flex: 1;
                    width: 100%;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    .down-icon{
                        width: 28px;
                        margin-left: 3px;
                        margin-top: 2px;
                    }
                    .option-wrap{
                        background: #FFFFFF;
                        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                        //border-radius: 12px;
                        position: absolute;
                        top: 68px;
                        left: 0;
                        z-index: 13;
                        max-height: 440px;
                        overflow-x: hidden;
                        overflow-y: scroll;
                        .option-item{
                            white-space: nowrap;
                            height: 80px;
                            font-size: 28px;
                            font-weight: 400;
                            color: #A1A1A1;
                            padding:20px 45px;
                            position: relative;
                            &:after{
                                content:'';
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 60%;
                                height: 2px;
                                background:#F6F6F6;
                            }
                        }
                    }
                }

            }

            .scroll-right {
                width: calc(100% - 250px);
                white-space: nowrap;
                .form-title {
                    text-align: center;
                    width: 155px;
                    display: inline-block;
                    white-space: nowrap;
                    position: relative;
                    &:nth-child(3){
                        width: 180px;
                    }
                    &:last-child{
                        width: 650px;
                    }
                    .down-icon{
                        width: 28px;
                        margin-left: 3px;
                        margin-top: 2px;
                    }
                    .option-wrap{
                        background: #FFFFFF;
                        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.07);
                        border-radius: 12px;
                        position: absolute;
                        top: 68px;
                        z-index: 13;
                        .option-item{
                            white-space: nowrap;
                            font-size: 28px;
                            font-weight: 400;
                            color: #A1A1A1;
                            padding:20px 45px;
                            position: relative;
                            &:after{
                                content:'';
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                                width: 60%;
                                height: 2px;
                                background:#F6F6F6;
                            }
                        }
                    }
                    .option-wrap-left{
                        right: 0 !important;
                    }
                    .option-wrap-right{
                        right: 0 !important;
                    }
                }
            }
        }
        .center-content{
            border: 2px solid #F5F7F6;
            border-top: 0;
            border-bottom: 0;
            width: 100%;
            .box{
                width: 670px;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #318544;
                font-size: 24px;
                font-weight: 400;
                color: #318544;
                line-height: 80px;
                text-align: center;
                margin: 16px auto;
            }
        }
        .form-content {
            width: 100%;
            //height: 700px;
            height: auto;
            //max-height: 700px;
            //min-height: 80px;
            border-radius: 16px 16px 0 0 ;
            border: 2px solid #F5F7F6;
            border-top: 0;
            border-bottom: 0;
            display: flex;
            //overflow-y: scroll;
            overflow-x: hidden;
            flex-wrap: wrap;

            .fixed-left {
                width: 250px;
                height: 100%;
                position: relative;
                z-index: 10;
                //overflow-y: scroll;
                .fixed-item-left {
                    width: 249px;
                    display: flex;
                    justify-content: center;
                    height: 90px;
                    align-items: center;
                    border-right: 1px solid #dcdfe6;

                    .form-title {
                        flex: 1;
                        text-align: center;
                        font-size: 28px;
                        color: rgba(0, 0, 0, 0.4);
                    }
                    .form-title-page-name{
                        font-size: 24px !important;
                    }
                }
            }

            .scroll-right {
                width: calc(100% - 250px);
                height: 100%;
                //overflow-x: scroll;
                //overflow-y: scroll;
                white-space: nowrap;

                .fixed-item-right {
                    width: 100%;
                    height: 90px;
                    line-height: 90px;

                    .form-title {
                        text-align: center;
                        width: 155px;
                        display: inline-block;
                        white-space: nowrap;
                        font-size: 28px;
                        color: rgba(0, 0, 0, 0.4);
                        &:nth-child(3){
                            width: 180px;
                        }
                        &:last-child{
                            width: 650px;
                        }
                    }
                }
                .tips{
                    font-size: 24px;
                    color:#a5a5a5;
                    height:80px;
                    line-height: 80px;
                }
            }

            .page-wrap{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin:20px 0;
                div{
                    width: 56px;
                    height: 56px;
                    border-radius: 4px;
                    border: 1px solid rgba(0,0,0,0.08);
                    font-size: 24px;
                    font-weight: 400;
                    color: #525F66;
                    margin: 0 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &:last-child{
                        border: 0;
                    }
                    &:first-child{
                        border: 0;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .num-page-active{
                    color: #2B447E;
                    border: 1px solid #008C2F;
                }
            }
        }
        .vant-pagination-wrap{
            width: 100%;
            display: flex;
            align-items: center;
            margin:20px 0;
            justify-content: center;
        }
        .tips-other{
            font-size: 24px;
            color:#a5a5a5;
            height:80px;
            line-height: 80px;
            width: 100%;
            text-align: center;
        }
    }
}
.map-plat{
    .van-swipe-item{
        .tips{
            transform: translateX(5px);
        }
    }
    .van-swipe-item-one{
        .form-tab-wrap{
            .fixed-left{
                width: 300px;
                .form-title{
                    flex: auto;
                    &:nth-child(1){
                        width: 125px;
                    }
                    &:nth-child(2){
                        width: 175px;
                    }
                }
            }
            .scroll-right{
                width: calc(100% - 300px);
            }
        }
        .form-content{
            .fixed-left{
                width: 300px;
                .fixed-item-left{
                    width: 299px;
                    .form-title{
                        flex: auto;
                        &:nth-child(1){
                            width: 125px;
                        }
                        &:nth-child(2){
                            width: 175px;
                        }
                    }
                }
            }
            .scroll-right{
                width: calc(100% - 300px);
            }
        }
    }
}
</style>

